import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { teamMembers } from '../mock';
import { Mail, Phone, ChevronDown } from 'lucide-react';
import { ScrollReveal } from '../components/ScrollReveal';

export const StudioMaintenancePage = () => {
  const scrollToTeam = () => {
    const teamSection = document.getElementById('team-section');
    if (teamSection) {
      const headerHeight = 65;
      const elementTop = teamSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementTop - headerHeight, behavior: 'smooth' });
    }
  };

  return (
    <div className="page-wrapper page-maintenance">
      <Header />
      
      {/* Maintenance Section - matches Projects page exactly */}
      <section className="maintenance-section">
        <ScrollReveal>
          <div className="maintenance-content">
            <h1 className="maintenance-title">Studio</h1>
            <div className="maintenance-divider"></div>
            <p className="maintenance-message">
              We&apos;re updating our website.
            </p>
            <p className="maintenance-submessage">
              Get to know our team.
            </p>
            <div className="scroll-arrow-container" onClick={scrollToTeam}>
              <ChevronDown className="scroll-arrow" size={32} />
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* Team Section */}
      <section id="team-section" className="home-section home-section-dark">
        <ScrollReveal>
          <div className="home-section-inner studio-team-section-centered">
            <div className="home-section-header studio-team-header-centered">
              <h2 className="section-title-inline title-light-text">
                <span className="title-light">OUR</span> <span className="title-bold">TEAM.</span>
              </h2>
            </div>
            <div className="studio-team-grid studio-team-dark">
              {teamMembers.map((member) => (
                <div key={member.id} className="studio-team-card studio-team-card-dark">
                  <h3 className="studio-team-name">{member.name}</h3>
                  <p className="studio-team-role">{member.role}</p>
                  <div className="studio-team-contact">
                    <a href={`tel:${member.phone.replace(/\s/g, '')}`} className="studio-contact-link">
                      <Phone size={14} />
                      <span>{member.phone}</span>
                    </a>
                    <a href={`mailto:${member.email}`} className="studio-contact-link">
                      <Mail size={14} />
                      <span>{member.email}</span>
                    </a>
                  </div>
                  {member.description && (
                    <p className="studio-team-description">{member.description}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </section>

      <Footer />
    </div>
  );
};
